import React, { useState } from "react";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import { useRef, useEffect } from "react";

const AsyncTypeAheadComponent = ({
  onSelected,
  clear,
  onClear,
  emptyLabel = "Keine Ergebnisse",
  promptText = "Searching...",
  placeholder = "Search...",
  valid,
  handleAddMember,
  users,
  validation,
}) => {
  const [emailList, setEmailList] = useState(users.map((user) => user.email));
  const typeaheadRef = useRef();

  const handleKeyPress = (event) => {
    if (event.key === "Enter" && valid) {
      handleAddMember();
    }
  };

  useEffect(() => {
    const userEmails = users.map((user) => user.email);
    const validatedEmail = new Set(
      validation.members.value.map((el) => el.email)
    );

    const filteredList = userEmails.filter(
      (email) => !validatedEmail.has(email)
    );

    setEmailList(filteredList);
  }, [users, validation]);

  useEffect(() => {
    if (clear && typeaheadRef.current) {
      typeaheadRef.current.clear();
      onClear();
      typeaheadRef.current.focus();
    }
  }, [clear, onClear]);

  const handleChange = (selected) => {
    onSelected(selected);
  };

  return (
    <AsyncTypeahead
      style={{
        borderBottomRightRadius: "0px",
        borderTopRightRadius: "0px",
      }}
      className="custom-typeahead"
      ref={typeaheadRef}
      isLoading={false}
      onSearch={() => {}}
      options={emailList}
      labelKey="name"
      placeholder={placeholder}
      onChange={handleChange}
      id="Email"
      autoFocus={true}
      emptyLabel={emptyLabel}
      promptText={promptText}
      onKeyDown={(event) => handleKeyPress(event)}
    />
  );
};

export default AsyncTypeAheadComponent;
